<template id="ListJobs">
    <div>
        <!-- Errori -->
        <b-alert v-if="errors && errors.length" variant="danger" show dismissible>
            <ul>
                <li v-for="error of errors" :key="error.id">
                    Errore : {{error.message}}
                </li>
            </ul>
        </b-alert>


        <b-card noBody>
            <b-tabs card fill>
                <b-tab title="Esecuzioni" active>

                    <h1>Esecuzioni</h1>
                    <div class="container">
                        <b-table :items="this.$store.state.SchedulerJobs" :primary-key="'id'" :fields="sfields" :sort-by="sortSchedBy" :sort-desc="sortSchedDesc" class="table_Cell">


                            <!-- enqueuedtime -->
                            <template v-slot:cell(enqueuedtime)="data">
                                {{FormatDate(data.item.enqueuedtime)}}
                            </template>

                            <!-- Job Type -->
                            <template v-slot:cell(jobtype)="data">
                                <font-awesome-icon size="lg" class="icon_azure" :icon="GetJobTypeIcon(data.item.fktype)"  />
                            </template>

                            <!-- Job Type -->
                            <template v-slot:cell(jobdesc)="data">
                                {{GetSchedJobDescription(data.item)}}
                            </template>




                            <!-- Job Status -->
                            <template v-slot:cell(fkstatus)="data">
                                <font-awesome-icon size="lg" :class="GetStatusColor(data.item.fkstatus)" :icon="GetStatusIcon(data.item.fkstatus)"  />
                            </template>



                            <template #cell(message)="data">

                                <font-awesome-icon size="lg" class="icon_azure" icon="info-circle" @click="data.toggleDetails" />

                            </template>

                            <template #row-details="data">
                                <b-card>
                                    <font-awesome-icon size="lg" class="icon_red" icon="window-close" @click="data.toggleDetails" />

                                    <!-- Status -->
                                    <b-row class="mb-2">
                                        <b-col sm="3" class="text-sm-right"><b>Status:</b></b-col>
                                        <b-col>{{GetJobStatusTypesDesc(data.item.fkstatus)}}</b-col>

                                        <b-col sm="1" class="text-sm-right"><b>Code:</b></b-col>
                                        <b-col>{{data.item.fkstatus}}</b-col>

                                    </b-row>

                                    <!-- Time Info -->
                                    <b-row class="mb-2">
                                        <b-col sm="3" class="text-sm-right"><b>Start:</b></b-col>
                                        <b-col>{{FormatDate(data.item.startedtime)}}</b-col>

                                        <b-col sm="1" class="text-sm-right"><b>End:</b></b-col>
                                        <b-col>{{FormatDate(data.item.endedtime)}}</b-col>

                                    </b-row>

                                    <b-row class="mb-8">
                                        <b-col sm="3" class="text-sm-right"><b>Message:</b></b-col>
                                        <b-col>{{ data.item.message }}</b-col>
                                    </b-row>

                                    <b-row v-if="data.item.fkstatus >= 200 && data.item.fkfilestore" class="mb-8">
                                        <b-col sm="3" class="text-sm-right"><b>File:</b></b-col>
                                        <b-col>
                                            <b-button variant="outline-success" size="sm" @click="DownloadFile(data.item.id)">
                                                <font-awesome-icon icon="download" /> Scarica file
                                            </b-button>
                                        </b-col>
                                    </b-row>

                                    <b-row v-if="data.item.fkstatus == 140" class="mb-8">
                                        <b-col sm="3" class="text-sm-right"><b>Answer:</b></b-col>
                                        <b-col sm="1"><b-button variant="outline-success" @click="SetAnswer(data.item,true)">Yes</b-button></b-col>
                                        <b-col sm="3"><b-button variant="outline-danger" @click="SetAnswer(data.item,false)">No</b-button></b-col>
                                    </b-row>

                                </b-card>
                            </template>

                        </b-table>
                    </div>



                </b-tab>

                <b-tab title="Job disponibili">

                    <b-card-group columns>
                        <template v-for="(rifjob, index) in this.RunningJobs">
                            <JobStatusCard :rifjob="rifjob" :key="index"></JobStatusCard>
                        </template>
                    </b-card-group>

                    <h1>Job disponibili</h1>
                    <div class="container">
                        <b-table :items="this.$store.state.Jobs" :primary-key="'id'" :fields="fields" class="table_Cell">
                            <!-- A virtual composite column -->
                            <template v-slot:cell(id)="data">
                                <font-awesome-icon size="lg" icon="play" @click="StartJob(data.item.id)" style="color:forestgreen" />
                            </template>
                        </b-table>
                    </div>

                    <!-- Modale parametri job -->
                    <b-modal v-model="showParamsModal" :title="'Parametri: ' + pendingJobDesc"
                             @ok="RunPendingJob" ok-title="Esegui" cancel-title="Annulla">
                        <b-form>
                            <b-form-group v-for="(val, key) in pendingJobParams" :key="key" :label="ParamLabel(key)">
                                <template v-if="pendingJobRefOptions[key]">
                                    <template v-if="pendingJobRefMulti[key]">
                                        <b-form-input
                                            size="sm" class="mb-1"
                                            v-model="pendingJobFilter[key]"
                                            placeholder="Filtra…">
                                        </b-form-input>
                                        <div class="mb-1">
                                            <b-button size="sm" variant="outline-secondary" @click="ToggleAllRef(key, true)">Seleziona tutti</b-button>
                                            <b-button size="sm" variant="outline-secondary" @click="ToggleAllRef(key, false)">Pulisci</b-button>
                                            <small class="text-muted ml-1">{{ (pendingJobParams[key] || []).length }} selezionati</small>
                                        </div>
                                        <div style="max-height: 220px; overflow-y: auto;" class="border rounded p-2">
                                            <b-form-checkbox-group
                                                v-model="pendingJobParams[key]"
                                                :options="FilteredRefOptions(key)"
                                                stacked>
                                            </b-form-checkbox-group>
                                        </div>
                                        <small class="text-muted">Lascia vuoto per usare la configurazione di default</small>
                                    </template>
                                    <b-form-select
                                        v-else
                                        v-model="pendingJobParams[key]"
                                        :options="pendingJobRefOptions[key]">
                                    </b-form-select>
                                </template>
                                <b-form-input v-else v-model="pendingJobParams[key]"></b-form-input>
                            </b-form-group>
                        </b-form>
                    </b-modal>

                </b-tab>                
            </b-tabs>
        </b-card>


        



        


        


    </div>
</template>

<style>
    .icon_red {        
        color: red;
    }
    .icon_orange {
        color: orange;
    }
    .icon_green {
        color: forestgreen;
    }
    .icon_azure {
        color: darkturquoise;
    }
</style>
<script>
    import axios from 'axios';
    import moment from 'moment';
    import JobStatusCard from './JobStatusCard.vue';
    export default {
        data() {
            return {
                errors: [],
                // Ordinamento di default della tabella "Scheduled Jobs": piu' recente in cima.
                // enqueuedtime e' una data ISO, quindi l'ordinamento stringa coincide con quello cronologico.
                sortSchedBy: 'enqueuedtime',
                sortSchedDesc: true,
                fields: [
                    {
                        key: 'description',
                        label: 'Job Name',
                        sortable: true
                    },
                    {
                        key: 'id',
                        sortable: false
                    },
                    
                ],
                sfields: [
                    {
                        key: 'enqueuedtime',
                        label: 'Date Time',
                        sortable: true
                    },
                    {
                        key: 'jobtype',
                        label: 'Type',
                        sortable: true
                    },
                    {
                        key: 'jobdesc',
                        label: 'Description',
                        sortable: true
                    },             
                    {
                        key: 'fkstatus',
                        label: 'Status',
                        sortable: true
                    },
                    {
                        key: 'message',
                        label: 'Info',
                        sortable: false
                    },
        

                ],
                sIcons: [
                    {
                        id: 100,
                        icon: 'clock',
                        class: 'icon_azure'
                    },
                    {
                        id: 140,
                        icon: 'question-circle',
                        class: 'icon_orange'
                    },
                    {
                        id: 150,
                        icon: 'play',
                        class: 'icon_green'
                    },
                    {
                        id: 220,
                        icon: 'exclamation-triangle',
                        class: 'icon_red'
                    },
                    {
                        id: 240,
                        icon: 'exclamation',
                        class: 'icon_orange'
                    },
                    {
                        id: 250,
                        icon: 'check-circle',
                        class: 'icon_green'
                    },
                ],
                RunningJobs: [],
                JobStatus: {},
                showParamsModal: false,
                pendingJobId: null,
                pendingJobDesc: '',
                pendingJobParams: {},
                pendingJobRefOptions: {},
                pendingJobRefMulti: {},
                pendingJobFilter: {},
                pendingJobLabels: {}
            }
        },
        components: {
            JobStatusCard
        },
        methods: {
            StartJob: async function (idjob) {
                let tJobDef = this.$store.state.Jobs.find(e => e.id == idjob);
                let rawParams = (Object.prototype.hasOwnProperty.call(tJobDef, 'jsonparams') && tJobDef.jsonparams)
                    ? tJobDef.jsonparams : null;

                this.pendingJobId = idjob;
                this.pendingJobDesc = tJobDef.description || '';
                this.pendingJobRefOptions = {};
                this.pendingJobRefMulti = {};
                this.pendingJobFilter = {};

                let parsed = rawParams ? JSON.parse(rawParams) : {};

                // Etichette "belle" opzionali: chiave speciale __labels nel JSON dei parametri.
                // I nomi tecnici (MESEINI, ...) restano invariati per combaciare con la SP.
                this.pendingJobLabels = (parsed && parsed.__labels && typeof parsed.__labels === 'object')
                    ? parsed.__labels : {};
                if (parsed.__labels) delete parsed.__labels;

                // Carica opzioni per i parametri __ref (combobox da entity)
                for (let key of Object.keys(parsed)) {
                    let val = parsed[key];
                    if (val && typeof val === 'object' && val.__ref) {
                        try {
                            // Look up the entity's registered controller path from the store.
                            // Entities with FkCompany=1 use a company-specific route (e.g. BevNet/CampariSoci)
                            // rather than the generic _main namespace.
                            let refEntity = this.$store.state.Entity &&
                                this.$store.state.Entity.find(e => e.csclass === val.__ref);
                            let apiPath = (refEntity && refEntity.controller)
                                ? 'api/' + refEntity.controller
                                : 'api/_main/' + val.__ref;
                            let resp = await axios.get(apiPath, this.$store.state.Headers);
                            let items = resp.data.Result || [];
                            this.$set(this.pendingJobRefOptions, key, items.map(i => ({
                                value: i[val.__valueField],
                                text:  i[val.__labelField] + ' (' + i[val.__valueField] + ')'
                            })));
                            this.$set(this.pendingJobRefMulti, key, !!val.__multi);
                            this.$set(this.pendingJobFilter, key, '');
                        } catch (e) {
                            this.errors.push(e);
                        }
                        this.$set(parsed, key, val.__multi ? [] : null);
                    }
                }

                if (Object.keys(parsed).length > 0) {
                    this.pendingJobParams = parsed;
                    this.showParamsModal = true;
                } else {
                    this.ExecuteJob(idjob, JSON.stringify({}));
                }
            },
            ParamLabel: function (key) {
                return (this.pendingJobLabels && this.pendingJobLabels[key]) ? this.pendingJobLabels[key] : key;
            },
            FilteredRefOptions: function (key) {
                let options = this.pendingJobRefOptions[key] || [];
                let filter = (this.pendingJobFilter[key] || '').trim().toLowerCase();
                if (!filter) return options;
                return options.filter(o => String(o.text).toLowerCase().indexOf(filter) !== -1);
            },
            ToggleAllRef: function (key, select) {
                if (!select) {
                    this.$set(this.pendingJobParams, key, []);
                    return;
                }
                // Seleziona tutte le voci attualmente visibili (rispettando il filtro),
                // unendole a quelle già selezionate.
                let current = this.pendingJobParams[key] || [];
                let visible = this.FilteredRefOptions(key).map(o => o.value);
                let merged = current.slice();
                for (let v of visible) if (merged.indexOf(v) === -1) merged.push(v);
                this.$set(this.pendingJobParams, key, merged);
            },
            RunPendingJob: function () {
                let params = Object.assign({}, this.pendingJobParams);
                for (let key of Object.keys(params)) {
                    if (Array.isArray(params[key])) {
                        params[key] = params[key].length > 0 ? params[key].join(',') : null;
                    }
                }
                this.ExecuteJob(this.pendingJobId, JSON.stringify(params));
            },
            ExecuteJob: function (idjob, jsonParams) {
                let self = this;
                var Link = 'api/_main/Jobs/runjob/' + idjob;
                axios.post(Link, "jsonParams=" + jsonParams, this.$store.state.Headers)
                    .then(response => {
                        var tResultId = response.data.Result;
                        self.GetJobStatus(tResultId);
                        self.RunningJobs.push(tResultId);
                    })
                    .catch(e => {
                        this.errors.push(e);
                    });
            },
            FormatDate: function (val) {
                if (val) {
                    return moment(String(val)).format('DD/MM hh:mm');
                }
            },
            GetJobTypeIcon: function (idtype) {
                if (idtype == 1) {
                    return "cogs";
                }
                else {
                    return "file-import";
                }                
            },
            GetJobStatus: function (idjobstatus) {
                if (idjobstatus) {
                    let self = this;
                    var Link = 'api/_main/SchedulerJob/' + idjobstatus;
                    axios.get(Link, this.$store.state.Headers)
                        .then(response => {
                            self.JobStatus = response.data.Result;                            
                        }).catch(e => {
                            this.errors.push(e);
                        });
                }

            },
            GetJobStatusTypesDesc: function (idtype) {
                return this.$store.state.JobStatusTypes.find(e => e.id == idtype).description;
            },
            GetSchedJobDescription: function (item) {                                        
                //Deve rimamanere solo description, appena � stato implementato...
                
                if (Object.prototype.hasOwnProperty.call(item, 'description')) {                
                    return item.description;
                }

                if (Object.prototype.hasOwnProperty.call(item, 'fkschedulerjobtemplate')) {                    
                    return this.$store.state.Jobs.find(e => e.id == item.fkschedulerjobtemplate).description;
                }

                if (Object.prototype.hasOwnProperty.call(item, 'fkfileloaderlayout')) {                    
                    return this.$store.state.FileLoaderLayouts.find(e => e.id == item.fkfileloaderlayout).label;
                }
                return item.message;
               
                                 
            },       
            GetStatusIcon: function (idstatus) {
                
                var tIcon = this.sIcons.find(e => e.id == idstatus);                
                if (tIcon) {                
                    return tIcon.icon;
                }
                else {
                    return 'bug';
                }
            },
            GetStatusColor: function (idstatus) {                
                var tIcon = this.sIcons.find(e => e.id == idstatus);                
                if (tIcon) {                
                    return tIcon.class;
                }
                else {
                    return 'icon_green';
                }
            },
            DownloadFile: function (jobId) {
                let config = Object.assign({}, this.$store.state.Headers, { responseType: 'blob' });
                axios.get('files/download/' + jobId, config)
                    .then(response => {
                        const disposition = response.headers['content-disposition'];
                        const fileName = disposition
                            ? (disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/) || [])[1] || 'export'
                            : 'export';
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const a = document.createElement('a');
                        a.href = url;
                        a.setAttribute('download', fileName.replace(/['"]/g, ''));
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url);
                    }).catch(e => {
                        this.errors.push(e);
                    });
            },
            SetAnswer: function (item, parAnswer) {
                var Link = parAnswer ? 'api/_main/Jobs/jobproceed/' + item.id : 'api/_main/Jobs/jobabort/' + item.id;
                // Aggiorna subito lo stato locale (non piu' 140) per nascondere i pulsanti
                // ed evitare un secondo click, che colpirebbe il job gia' ripartito
                // generando "Job not waiting for user input".
                item.fkstatus = parAnswer ? 150 : 220;
                axios.get(Link, this.$store.state.Headers)
                    .catch(e => {
                        this.errors.push(e);
                    });
            }

  
        }
    }
</script>